export const deCommon = {
  // SEO
  'seo.title.home': 'Bewertungsmanagement Software Deutschland | AI-gestützte Bewertungen automatisieren | REPUTRUST',
  'seo.description.home': 'Automatisieren Sie Ihr Bewertungsmanagement mit KI-gestützter Software. AI-Auto-Antwort für Google-Bewertungen, automatisches Social-Media-Teilen und vollständige Google Business Profil-Verwaltung. 7 Tage kostenlos testen.',
  'seo.title.blog': 'Blog & Expertenwissen | Online-Reputation & Bewertungsmanagement | REPUTRUST',
  'seo.description.blog': 'Entdecken Sie Tipps, Best Practices und Strategien zur Optimierung Ihrer Online-Reputation und zur Steigerung Ihrer Kundenbewertungen.',
  'seo.title.caseStudies': 'Erfolgsgeschichten & Referenzen | REPUTRUST',
  'seo.description.caseStudies': 'Erfahren Sie, wie Unternehmen aus verschiedenen Branchen mit REPUTRUST ihre Online-Reputation verbessert haben.',
  'seo.title.help': 'Hilfe-Center & Support | REPUTRUST',
  'seo.description.help': 'Durchsuchen Sie unsere Wissensdatenbank oder kontaktieren Sie unser Support-Team.',
  'seo.title.webinars': 'Webinare & Online-Schulungen | REPUTRUST',
  'seo.description.webinars': 'Lernen Sie von Experten, wie Sie Ihr Bewertungsmanagement optimieren.',
  'seo.title.legal': 'Rechtliche Informationen | REPUTRUST',

  // Navigation
  'nav.blog': 'Blog',
  'nav.caseStudies': 'Case Studies',
  'nav.help': 'Hilfe',
  'nav.login': 'Anmelden',
  'nav.freeTrial': 'Kostenlos testen',

  // Common
  'common.learnMore': 'Mehr erfahren',
  'common.getStarted': 'Jetzt starten',
  'common.contactUs': 'Kontaktieren Sie uns',

  // Hero Section
  'hero.badge': 'AI-gestützte Bewertungsautomatisierung',
  'hero.title': 'Ihr automatisierter',
  'hero.titleHighlight': 'Bewertungsagent',
  'hero.subtitle': 'Automatisierte Antworten, Social Media & Google-Profil-Verwaltung.',
  'hero.benefit1': 'Automatische AI-Antworten auf alle Bewertungen',
  'hero.benefit2': 'Social-Media-Posts automatisch generieren',
  'hero.benefit3': 'Google Business Profil zentral verwalten',
  'hero.ctaPrimary': 'Kostenlos testen',
  'hero.ctaSecondary': 'Live-Demo buchen',
  'hero.trustCustomers': 'zufriedene Kunden',
  'hero.trustRating': 'Bewertung',
  'hero.dashboardTitle': 'Dashboard',
  'hero.dashboardPeriod': 'Letzte 30 Tage',
  'hero.stat1': 'Bewertungen beantwortet',
  'hero.stat2': 'Social Posts erstellt',
  'hero.activity1': '5★ Bewertung automatisch beantwortet',
  'hero.activity1Time': 'vor 2 Minuten',
  'hero.activity2': 'Instagram-Post veröffentlicht',
  'hero.activity2Time': 'vor 15 Minuten',
  'hero.statusActive': 'Alle Systeme aktiv',

  // Problem Section
  'problem.badge': 'Die Herausforderung',
  'problem.title': 'Bewertungen verwalten',
  'problem.titleHighlight': 'kostet Zeit',
  'problem.subtitle': 'Ohne Automatisierung wird Bewertungsmanagement zum Vollzeitjob',
  'problem.problem1.title': 'Zeitaufwendig',
  'problem.problem1.desc': 'Jede Bewertung manuell zu beantworten kostet täglich Stunden',
  'problem.problem1.stat': 'Bis zu 2 Std. täglich',
  'problem.problem2.title': 'Inkonsistent',
  'problem.problem2.desc': 'Antwortqualität variiert je nachdem, wer antwortet',
  'problem.problem2.stat': 'Bis zu 40% weniger Sichtbarkeit',
  'problem.problem3.title': 'Verpasste Chancen',
  'problem.problem3.desc': 'Ohne aktiven Bewertungsaufbau bleiben positive Kundenerfahrungen unsichtbar und Ihre Reputation stagniert.',
  'problem.problem3.stat': '85% der Kunden lesen Bewertungen',
  'problem.problem4.title': 'Negative Bewertungen',
  'problem.problem4.desc': 'Unbeantwortete negative Bewertungen schaden Ihrem Image und schrecken potenzielle Kunden ab.',
  'problem.problem4.stat': '30% Umsatzverlust möglich',
  'problem.problem5.title': 'Fehlende Social-Media-Präsenz',
  'problem.problem5.desc': 'Positive Bewertungen werden nicht für Social Media genutzt, wodurch wertvolle Marketing-Chancen verloren gehen.',
  'problem.problem5.stat': 'Verpasste Reichweite',
  'problem.problem6.title': 'Schwache Online-Reputation',
  'problem.problem6.desc': 'Ohne kontinuierliche Bewertungsgenerierung und -pflege verlieren Sie im Wettbewerb gegen Konkurrenten mit besserer Reputation.',
  'problem.problem6.stat': 'Konkurrenz überholt Sie',
  'problem.impact.title': 'Die Kosten von schlechtem Bewertungsmanagement',
  'problem.impact.subtitle': 'Google\'s neue Algorithmus-Updates machen Reputation zum entscheidenden Ranking-Faktor',
  'problem.impact.stat1': '40%',
  'problem.impact.stat1.desc': 'weniger Google-Sichtbarkeit ohne gute Reputation',
  'problem.impact.stat2': '2h',
  'problem.impact.stat2.desc': 'täglich für manuelles Bewertungsmanagement',
  'problem.impact.stat3': '85%',
  'problem.impact.stat3.desc': 'der Kunden lesen Bewertungen vor dem Kauf',
  'problem.impact.stat4': '30%',
  'problem.impact.stat4.desc': 'Umsatzverlust durch negative Bewertungen',

  // Solution Section
  'solution.badge': 'Die Lösung',
  'solution.title': 'Automatisiertes',
  'solution.titleHighlight': 'Bewertungsmanagement',
  'solution.subtitle': 'Unsere AI übernimmt alles für Sie - von Antworten bis Social Media',
  'solution.module1.feature1': 'Natürliche Sprache',
  'solution.module1.feature2': 'Tonalität anpassbar',
  'solution.module1.feature3': '24/7 verfügbar',
  'solution.module1.feature4': 'Google-optimiert',
  'solution.module2.feature1': 'Automatische E-Mail-Kampagnen',
  'solution.module2.feature2': 'SMS-Erinnerungen',
  'solution.module2.feature3': 'QR-Code-Generator',
  'solution.module2.feature4': 'Timing-Optimierung',
  'solution.module3.feature1': 'Instagram & Facebook',
  'solution.module3.feature2': 'Automatische Planung',
  'solution.module3.feature3': 'Optimierte Hashtags',
  'solution.module3.feature4': 'Story-Templates',
  'solution.module4.feature1': 'Multi-Location Support',
  'solution.module4.feature2': 'Ranking-Tracking',
  'solution.module4.feature3': 'Wettbewerbs-Analyse',
  'solution.module4.feature4': 'SEO-Optimierung',
  'solution.module1.title': 'KI-Bewertungs-Agent',
  'solution.module1.desc': 'Unsere KI beantwortet jede Bewertung individuell, professionell und in Rekordzeit.',
  'solution.module2.title': 'Bewertungs-Boost',
  'solution.module2.desc': 'Generieren Sie systematisch mehr positive Bewertungen über E-Mail, SMS und QR-Codes.',
  'solution.module3.title': 'Social-Media-Automation',
  'solution.module3.desc': 'Verwandeln Sie positive Bewertungen automatisch in attraktive Social-Media-Posts.',
  'solution.module4.title': 'Google Business Manager',
  'solution.module4.desc': 'Zentrale Verwaltung aller Google-Unternehmensprofile und Standorte in einem Dashboard.',
  'solution.stat1': 'Zeitersparnis',
  'solution.stat2': 'Mehr Bewertungen',
  'solution.stat3': 'Google-Sichtbarkeit',
  'solution.stat4': 'Verfügbarkeit',

  // Testimonials Section
  'testimonials.badge': 'Erfolgsgeschichten',
  'testimonials.title': 'Was unsere',
  'testimonials.titleHighlight': 'Kunden sagen',
  'testimonials.subtitle': 'Über 2.500 Unternehmen vertrauen unserer Plattform',
  'testimonials.testimonial1.text': 'Seit wir REPUTRUST nutzen, sparen wir täglich 2 Stunden. Die AI-Antworten sind perfekt und unsere Bewertungen haben sich um 40% verbessert!',
  'testimonials.testimonial1.author': 'Dr. Sarah Müller',
  'testimonials.testimonial1.role': 'Zahnärztin',
  'testimonials.testimonial1.company': 'Zahnarztpraxis München',
  'testimonials.testimonial2.text': 'Die automatischen Social-Media-Posts sind genial! Unsere Reichweite hat sich verdreifacht und wir bekommen deutlich mehr Reservierungen.',
  'testimonials.testimonial2.author': 'Michael Weber',
  'testimonials.testimonial2.role': 'Geschäftsführer',
  'testimonials.testimonial2.company': 'Restaurant Bella Vista',
  'testimonials.testimonial3.text': 'Endlich haben wir alle Bewertungen im Griff. Das Dashboard ist übersichtlich und die Automationen funktionieren einwandfrei. Absolute Empfehlung!',
  'testimonials.testimonial3.author': 'Anna Schmidt',
  'testimonials.testimonial3.role': 'Marketing Managerin',
  'testimonials.testimonial3.company': 'Fitness Studio Hamburg',
  'testimonials.trustRate': 'Aktive Kunden',
  'testimonials.managed': 'Bewertungen verwaltet',
  'testimonials.satisfaction': 'Kundenzufriedenheit',
  'testimonials.avgRating': 'Durchschnittsbewertung',

  // CTA Section
  'cta.badge': 'Starten Sie jetzt kostenlos',
  'cta.title': 'Bereit, Ihr Bewertungsmanagement',
  'cta.titleHighlight': 'zu revolutionieren?',
  'cta.subtitle': 'Starten Sie noch heute mit unserer 7-tägigen kostenlosen Testversion.',
  'cta.benefit1': '7 Tage kostenlos testen',
  'cta.benefit2': 'Jederzeit kündbar',
  'cta.ctaPrimary': 'Kostenlos starten',
  'cta.ctaSecondary': 'Demo buchen',

  // Footer
  'footer.tagline': 'Ihr automatisierter Bewertungs-Agent',
  'footer.description': 'AI-gestütztes Bewertungsmanagement, Social-Media-Automatisierung und vollständige Kontrolle über Ihr Google-Unternehmensprofil.',
  'footer.product': 'Produkt',
  'footer.features': 'Features',
  'footer.pricing': 'Preise',
  'footer.caseStudies': 'Case Studies',
  'footer.webinars': 'Webinare',
  'footer.company': 'Unternehmen',
  'footer.about': 'Über uns',
  'footer.blog': 'Blog',
  'footer.careers': 'Karriere',
  'footer.contact': 'Kontakt',
  'footer.support': 'Support',
  'footer.helpCenter': 'Hilfe-Center',
  'footer.documentation': 'Dokumentation',
  'footer.apiDocs': 'API-Dokumentation',
  'footer.status': 'System-Status',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'AGB',
  'footer.imprint': 'Impressum',
  'footer.cookies': 'Cookie-Richtlinie',
  'footer.copyright': '© {{year}} reputrust.ai – Alle Rechte vorbehalten',
  'header.contactSupport': 'Fragen? Wir helfen gerne!',
  'dashboard.badge': 'Leistungsstarkes Dashboard',
  'dashboard.title': 'Ihr',
  'dashboard.titleHighlight': 'Kontrollzentrum',
  'dashboard.subtitle': 'Alle Bewertungen, Automationen und Analysen an einem Ort – übersichtlich, intuitiv und leistungsstark',
  'dashboard.nav.dashboard': 'Dashboard',
  'dashboard.nav.reviews': 'Bewertungen',
  'dashboard.nav.requests': 'Anfragen',
  'dashboard.nav.shared': 'Teilen',
  'dashboard.nav.widgets': 'Widgets',
  'dashboard.nav.googleProfile': 'Profil',
  'dashboard.nav.aiAgent': 'AI Agent',
  'dashboard.nav.settings': 'Einstellungen',
  'dashboard.home.nav.overview': 'Übersicht',
  'dashboard.home.nav.performance': 'Performance',
  'dashboard.home.nav.sentiment': 'Stimmung',
  'dashboard.home.nav.competitors': 'Wettbewerber',
  'dashboard.welcome': 'Willkommen zurück! Hier ist Ihre Übersicht.',
  'dashboard.mock.company': 'Ihr Unternehmen',
  'dashboard.mock.domain': 'ihrunternehmen.de',
  'dashboard.mock.connected': 'Verbunden',
  'dashboard.mock.manage': 'Verwalten',
  'dashboard.search': 'Suchen...',
  'dashboard.stat1.label': 'Ø Bewertung',
  'dashboard.stat1.change': '+0.3',
  'dashboard.stat2.label': 'Antwortrate',
  'dashboard.stat2.change': '+12%',
  'dashboard.stat3.label': 'Social Posts',
  'dashboard.stat3.change': '+45',
  'dashboard.activity.title': 'Letzte Aktivitäten',
  'dashboard.activity1.name': 'Sarah M.',
  'dashboard.activity1.action': 'Neue 5★ Bewertung',
  'dashboard.activity1.time': '2 Min',
  'dashboard.activity1.status': 'Beantwortet',
  'dashboard.activity2.name': 'Michael K.',
  'dashboard.activity2.action': 'Bewertung geteilt',
  'dashboard.activity2.time': '15 Min',
  'dashboard.activity2.status': 'Geteilt',
  'dashboard.activity3.name': 'Anna B.',
  'dashboard.activity3.action': 'Neue 5★ Bewertung',
  'dashboard.activity3.time': '1 Std',
  'dashboard.activity3.status': 'Beantwortet',
  'dashboard.activity4.name': 'Thomas W.',
  'dashboard.activity4.action': 'Kampagne gesendet',
  'dashboard.activity4.time': '2 Std',
  'dashboard.activity4.status': 'Versendet',
  'dashboard.modules.title': 'AI-Module',
  'dashboard.module1.name': 'Auto-Antwort',
  'dashboard.module1.desc': 'Automatische Bewertungsantworten',
  'dashboard.module2.name': 'Auto-Teilen',
  'dashboard.module2.desc': 'Social Media Automatisierung',
  'dashboard.module3.name': 'Auto-Kampagnen',
  'dashboard.module3.desc': 'Bewertungsanfragen versenden',
  'dashboard.modules.cta': 'Module konfigurieren',

  // Dashboard - Stats
  'dashboard.stats.aggregatedReviews': 'Kumulierte Bewertungen',
  'dashboard.stats.privateFeedback': 'Privates Feedback',
  'dashboard.stats.reviews': 'Bewertungen',
  'dashboard.stats.rating': 'Bewertung',
  'dashboard.stats.goal': '5-Sterne Bewertungen bis 4.9!',

  // Dashboard - Reviews
  'dashboard.reviews.title': 'Bewertungen',
  'dashboard.reviews.filter': 'Filter',
  'dashboard.reviews.quickRequest': 'Schnellanfrage',
  'dashboard.reviews.editReply': 'Antwort bearbeiten',
  'dashboard.reviews.deleteReply': 'Antwort löschen',
  'dashboard.reviews.review1.text': 'Wir waren begeistert! Das Team ist absolut spitze in Fachkompetenz, Zuverlässigkeit und Kundenorientierung...',
  'dashboard.reviews.review1.reply': 'Vielen Dank für Ihre wunderbare Bewertung! Wir freuen uns sehr, dass Sie mit unserem Service zufrieden sind.',
  'dashboard.reviews.review2.text': 'Alles super! Danke!',
  'dashboard.reviews.review2.reply': 'Freut uns zu hören, danke! Hoffentlich bis bald. 😊',
  'dashboard.reviews.review3.text': 'Top Service, gerne wieder.',
  'dashboard.reviews.review3.reply': 'Danke Carsten!',
  'dashboard.reviews.review1.date': '11. Mai 2025',
  'dashboard.reviews.review1.replyDate': '22. Jan',
  'dashboard.reviews.review2.date': '29. Februar 2024',
  'dashboard.reviews.review2.replyDate': '19. Apr',
  'dashboard.reviews.review3.date': '20. Juli 2023',
  'dashboard.reviews.review3.replyDate': '21. Juli',

  // Dashboard - Requests
  'dashboard.requests.title': 'Anfragen',
  'dashboard.requests.send': 'Senden',
  'dashboard.requests.templates': 'Vorlagen',
  'dashboard.requests.contacts': 'Kontakte',
  'dashboard.requests.optIn': 'Opt-In',
  'dashboard.requests.autoCampaign': 'Auto-Kampagne',
  'dashboard.requests.newTemplate': 'Neue Vorlage',
  'dashboard.requests.active': 'Aktiv',
  'dashboard.requests.channel': 'Kanal',
  'dashboard.requests.email': 'E-Mail',
  'dashboard.requests.preview': 'Vorschau',
  'dashboard.requests.success': 'Vorlage erfolgreich erstellt',
  'dashboard.requests.campaignNameMock': 'Bewertungskampagne...',
  'dashboard.requests.dateMock': '12. Februar',

  // Dashboard - Shared
  'dashboard.shared.title': 'Teilen Sie Ihre Bewertungen',
  'dashboard.shared.desc': 'Präsentieren Sie Ihre glücklichsten Kunden, indem Sie Ihre 4- und 5-Sterne-Bewertungen in sozialen Medien veröffentlichen. Einfach auf "Teilen" drücken und sofort mehr Vertrauen aufbauen.',
  'dashboard.shared.cta': 'Zu den Bewertungen',

  // Dashboard - Widgets
  'dashboard.widgets.title': 'Website-Widgets',
  'dashboard.widgets.carousel.title': 'Bewertungs-Karussell',
  'dashboard.widgets.carousel.desc': 'Präsentieren Sie Ihre besten Bewertungen in einem eleganten Slider.',
  'dashboard.widgets.list.title': 'Bewertungs-Liste',
  'dashboard.widgets.list.desc': 'Zeigen Sie alle Bewertungen in einer sauberen Liste an.',
  'dashboard.widgets.badge.title': 'Bewertungs-Badge',
  'dashboard.widgets.badge.desc': 'Ein kompaktes Badge, das Ihre Gesamtbewertung zeigt.',
  'dashboard.widgets.popup.title': 'Popup-Benachrichtigung',
  'dashboard.widgets.popup.desc': 'Zeigen Sie neue Bewertungen live als Popup an.',
  'dashboard.widgets.preview': 'Vorschau',
  'dashboard.widgets.install': 'Installieren',

  // Dashboard - Profile (Google)
  'dashboard.profile.performance': 'Performance Übersicht',
  'dashboard.profile.views': 'Aufrufe (Maps)',
  'dashboard.profile.clicks': 'Webseiten-Klicks',
  'dashboard.profile.calls': 'Anrufe',
  'dashboard.profile.thisMonth': 'diesen Monat',

  // Dashboard - AI Agent
  'dashboard.ai.title': 'AI Antwort-Assistent',
  'dashboard.ai.subtitle': 'Konfigurieren Sie, wie die KI auf Ihre Bewertungen antwortet.',
  'dashboard.ai.autoReply': 'Auto-Reply',
  'dashboard.ai.tonality': 'Tonalität',
  'dashboard.ai.tone.professional': 'Professionell',
  'dashboard.ai.tone.friendly': 'Freundlich',
  'dashboard.ai.tone.empathic': 'Empathisch',
  'dashboard.ai.tone.example': 'Beispiel Antwort Text...',
  'dashboard.ai.signature': 'Signatur',
  'dashboard.ai.signature.placeholder': 'Mit freundlichen Grüßen,\\nIhr IhrUnternehmen Team',

  // Dashboard - Settings
  'dashboard.settings.title': 'Einstellungen',
  'dashboard.settings.general': 'Allgemein',
  'dashboard.settings.notifications': 'Benachrichtigungen',
  'dashboard.settings.team': 'Team',
  'dashboard.settings.billing': 'Abrechnung',
  'dashboard.settings.integrations': 'Integrationen',
  'dashboard.settings.generalInfo': 'Allgemeine Informationen',
  'dashboard.settings.companyName': 'Firmenname',
  'dashboard.settings.website': 'Webseite',
  'dashboard.settings.save': 'Änderungen speichern',
  'dashboard.footer': 'Optimiert für Desktop, Tablet und Handy',

  // Features Section
  'features.badge': 'Weitere Features',
  'features.title': 'Alles was Sie',
  'features.titleHighlight': 'brauchen',
  'features.subtitle': 'Eine komplette Plattform für professionelles Bewertungsmanagement',
  'features.feature1.title': 'Google Business Integration',
  'features.feature1.desc': 'Direkter Zugriff auf Ihr Google-Unternehmensprofil',
  'features.feature2.title': 'Detaillierte Analysen',
  'features.feature2.desc': 'Umfassende Statistiken und Insights',
  'features.feature3.title': 'Multi-User Support',
  'features.feature3.desc': 'Teamverwaltung mit Rollen und Rechten',
  'features.feature4.title': 'Echtzeit-Benachrichtigungen',
  'features.feature4.desc': 'Sofortige Alerts bei neuen Bewertungen',
  'features.feature5.title': 'DSGVO-konform',
  'features.feature5.desc': 'Höchste Sicherheits- und Datenschutzstandards',
  'features.feature6.title': 'Premium Support',
  'features.feature6.desc': 'Persönlicher Support per Chat, E-Mail & Telefon',

  // Pricing Section
  'pricing.badge': 'Preise',
  'pricing.title': 'Transparente',
  'pricing.titleHighlight': 'Preisgestaltung',
  'pricing.subtitle': 'Wählen Sie den perfekten Plan für Ihr Unternehmen',
  'pricing.monthly': 'Monatlich',
  'pricing.annually': 'Jährlich',
  'pricing.discount': '-20%',
  'pricing.perMonth': '/Monat',
  'pricing.billedAnnually': 'Jährlich abgerechnet',
  'pricing.year': '/Jahr',
  'pricing.popularBadge': 'Beliebteste Wahl',
  'pricing.business.name': 'Business',
  'pricing.business.desc': 'Für wachsende Unternehmen',
  'pricing.business.feature2': 'AI-Bewertungs-Agent',
  'pricing.business.feature3': 'AI-Auto-Teilen (Instagram & Facebook)',
  'pricing.business.feature4': 'Google Business Manager',
  'pricing.business.feature5': 'Email monatlich: unbegrenzt',
  'pricing.business.feature6': 'Advanced Analytics',
  'pricing.business.feature7': 'Multi-Location Support',
  'pricing.enterprise.name': 'Enterprise',
  'pricing.enterprise.desc': 'Für große Organisationen',
  'pricing.enterprise.feature2': 'Alle Business Features',
  'pricing.enterprise.feature3': 'Custom AI Training',
  'pricing.enterprise.feature4': 'Dedicated Account Manager',
  'pricing.enterprise.feature5': 'API Access',
  'pricing.enterprise.feature6': 'Custom Integrations',
  'pricing.enterprise.feature7': 'SMS monatlich: 150+',
  'pricing.enterprise.feature8': 'WhatsApp monatlich: 150+',
  'pricing.enterprise.feature9': 'Multi-Location Support',
  'pricing.cta': 'Jetzt starten',
  'pricing.note': 'Alle Pläne beinhalten eine',
  'pricing.noteBold': '7-tägige kostenlose Testphase',
  'pricing.noteEnd': 'ohne Kreditkarte',

  // Blog Page
  'blog.badge': 'Blog & Ressourcen',
  'blog.title': 'Bewertungsmanagement Expertenwissen',
  'blog.subtitle': 'Entdecken Sie Tipps, Best Practices und Strategien zur Optimierung Ihrer Online-Reputation und zur Steigerung Ihrer Kundenbewertungen.',
  'blog.categories.all': 'Alle',
  'blog.categories.reviewManagement': 'Bewertungsmanagement',
  'blog.categories.technology': 'Technologie',
  'blog.categories.marketing': 'Marketing',
  'blog.categories.seoLocal': 'SEO & Local Marketing',
  'blog.categories.customerService': 'Kundenservice',
  'blog.categories.legal': 'Recht & Compliance',
  'blog.readMore': 'Weiterlesen',
  'blog.loadMore': 'Mehr Artikel laden',
  'blog.newsletter.title': 'Bleiben Sie auf dem Laufenden',
  'blog.newsletter.subtitle': 'Erhalten Sie die neuesten Artikel, Tipps und Updates direkt in Ihr Postfach.',
  'blog.newsletter.placeholder': 'Ihre E-Mail-Adresse',
  'blog.newsletter.cta': 'Abonnieren',
  'blog.readTime': 'Min. Lesezeit',

  // Case Studies Page
  'caseStudies.badge': 'Erfolgsgeschichten',
  'caseStudies.title': 'Case Studies: Erfolgreiche Kunden',
  'caseStudies.subtitle': 'Erfahren Sie, wie Unternehmen aus verschiedenen Branchen mit reputrust.ai ihre Online-Reputation verbessert und messbare Erfolge erzielt haben.',
  'caseStudies.stats.customers.value': '500+',
  'caseStudies.stats.customers.label': 'Zufriedene Kunden',
  'caseStudies.stats.increase.value': '+187%',
  'caseStudies.stats.increase.label': 'Ø Bewertungssteigerung',
  'caseStudies.stats.rating.value': '4.8',
  'caseStudies.stats.rating.label': 'Ø Kundenbewertung',
  'caseStudies.stats.recommendation.value': '98%',
  'caseStudies.stats.recommendation.label': 'Weiterempfehlungsrate',
  'caseStudies.challenge': 'HERAUSFORDERUNG',
  'caseStudies.solution': 'LÖSUNG',
  'caseStudies.duration': 'Zeitraum:',
  'caseStudies.cta.title': 'Werden Sie unsere nächste Erfolgsgeschichte',
  'caseStudies.cta.subtitle': 'Starten Sie jetzt mit Ihrer 7-tägigen kostenlosen Testphase und erleben Sie selbst, wie reputrust.ai Ihr Unternehmen voranbringt.',
  'caseStudies.cta.primary': 'Kostenlos testen',
  'caseStudies.cta.secondary': 'Demo buchen',

  // Case Study 1
  'caseStudies.item1.company': 'Dr. med. Klaus Weidinger',
  'caseStudies.item1.industry': 'Arztpraxis',
  'caseStudies.item1.challenge': 'Zu wenige Online-Bewertungen und keine systematische Bewertungsgenerierung',
  'caseStudies.item1.solution': 'Implementierung von QR-Codes im Wartezimmer und automatisierte E-Mail-Kampagnen nach Terminen',
  'caseStudies.item1.results.res1.metric': '+287%',
  'caseStudies.item1.results.res1.label': 'Mehr Bewertungen',
  'caseStudies.item1.results.res2.metric': '4.9',
  'caseStudies.item1.results.res2.label': 'Durchschnittsbewertung',
  'caseStudies.item1.results.res3.metric': '+156%',
  'caseStudies.item1.results.res3.label': 'Neue Patienten',
  'caseStudies.item1.testimonial': 'Seit wir reputrust.ai nutzen, haben wir deutlich mehr positive Bewertungen. Die Plattform ist einfach zu bedienen und spart uns viel Zeit.',
  'caseStudies.item1.duration': '6 Monate',

  // Case Study 2
  'caseStudies.item2.company': 'Restaurant Bella Vista',
  'caseStudies.item2.industry': 'Gastronomie',
  'caseStudies.item2.challenge': 'Negative Bewertungen auf mehreren Plattformen und keine Zeit für professionelle Antworten',
  'caseStudies.item2.solution': 'AI-gestützte automatische Antworten und Bewertungsfilter zur Vermeidung negativer öffentlicher Bewertungen',
  'caseStudies.item2.results.res1.metric': '+92%',
  'caseStudies.item2.results.res1.label': 'Positive Bewertungen',
  'caseStudies.item2.results.res2.metric': '-78%',
  'caseStudies.item2.results.res2.label': 'Negative Bewertungen',
  'caseStudies.item2.results.res3.metric': '+43%',
  'caseStudies.item2.results.res3.label': 'Reservierungen',
  'caseStudies.item2.testimonial': 'Die AI-Antwortfunktion ist fantastisch! Wir sparen täglich Stunden und unsere Antworten sind immer professionell und freundlich.',
  'caseStudies.item2.duration': '4 Monate',

  // Case Study 3
  'caseStudies.item3.company': 'Immobilien Weber GmbH',
  'caseStudies.item3.industry': 'Immobilien',
  'caseStudies.item3.challenge': 'Geringe Social-Media-Präsenz und keine Nutzung von Kundenbewertungen für Marketing',
  'caseStudies.item3.solution': 'Automatische Social-Media-Posts mit positiven Bewertungen und CI-konformen Grafiken',
  'caseStudies.item3.results.res1.metric': '+340%',
  'caseStudies.item3.results.res1.label': 'Social Media Reichweite',
  'caseStudies.item3.results.res2.metric': '+125%',
  'caseStudies.item3.results.res2.label': 'Website-Besucher',
  'caseStudies.item3.results.res3.metric': '+89%',
  'caseStudies.item3.results.res3.label': 'Anfragen',
  'caseStudies.item3.testimonial': 'Die automatische Social-Media-Integration hat unsere Online-Präsenz komplett verändert. Wir erreichen jetzt viel mehr potenzielle Kunden.',
  'caseStudies.item3.duration': '8 Monate',

  // Case Study 4
  'caseStudies.item4.company': 'Autohaus Müller & Söhne',
  'caseStudies.item4.industry': 'Automobilhandel',
  'caseStudies.item4.challenge': 'Mehrere Standorte ohne zentrale Bewertungsverwaltung und inkonsistente Google-Profile',
  'caseStudies.item4.solution': 'Zentrales Dashboard für alle Standorte mit einheitlichem Bewertungsmanagement und Google Business Profile-Verwaltung',
  'caseStudies.item4.results.res1.metric': '+215%',
  'caseStudies.item4.results.res1.label': 'Bewertungen gesamt',
  'caseStudies.item4.results.res2.metric': '100%',
  'caseStudies.item4.results.res2.label': 'Profil-Vollständigkeit',
  'caseStudies.item4.results.res3.metric': '+67%',
  'caseStudies.item4.results.res3.label': 'Verkaufsanfragen',
  'caseStudies.item4.testimonial': 'Endlich haben wir alle Standorte zentral im Blick. Die Verwaltung ist so viel einfacher geworden und unsere Google-Profile sind perfekt optimiert.',
  'caseStudies.item4.duration': '5 Monate',

  // Case Study 5
  'caseStudies.item5.company': 'Fitness Studio PowerGym',
  'caseStudies.item5.industry': 'Fitness & Wellness',
  'caseStudies.item5.challenge': 'Hohe Mitgliederfluktuation und wenig Feedback zur Verbesserung des Angebots',
  'caseStudies.item5.solution': 'Automatisierte Bewertungsanfragen nach Probetrainings und internes Feedback-System für negative Erfahrungen',
  'caseStudies.item5.results.res1.metric': '+178%',
  'caseStudies.item5.results.res1.label': 'Mitglieder-Feedback',
  'caseStudies.item5.results.res2.metric': '-45%',
  'caseStudies.item5.results.res2.label': 'Kündigungsrate',
  'caseStudies.item5.results.res3.metric': '+112%',
  'caseStudies.item5.results.res3.label': 'Neumitglieder',
  'caseStudies.item5.testimonial': 'Wir verstehen jetzt viel besser, was unsere Mitglieder wollen. Das Feedback hilft uns, unser Angebot kontinuierlich zu verbessern.',
  'caseStudies.item5.duration': '7 Monate',

  // Case Study 6
  'caseStudies.item6.company': 'Hotel Alpenblick',
  'caseStudies.item6.industry': 'Hotellerie',
  'caseStudies.item6.challenge': 'Bewertungen auf über 10 verschiedenen Plattformen ohne zentrale Übersicht',
  'caseStudies.item6.solution': 'Zentrale Bewertungsverwaltung für alle Plattformen mit automatischen Antworten und Analyse-Dashboard',
  'caseStudies.item6.results.res1.metric': '+95%',
  'caseStudies.item6.results.res1.label': 'Antwortrate',
  'caseStudies.item6.results.res2.metric': '4.8',
  'caseStudies.item6.results.res2.label': 'Durchschnittsbewertung',
  'caseStudies.item6.results.res3.metric': '+134%',
  'caseStudies.item6.results.res3.label': 'Direktbuchungen',
  'caseStudies.item6.testimonial': 'Die zentrale Verwaltung aller Bewertungsplattformen spart uns täglich mehrere Stunden. Wir können jetzt viel schneller auf Gästefeedback reagieren.',
  'caseStudies.item6.duration': '6 Monate',

  // Help Center Page
  'help.badge': 'Hilfe & Support',
  'help.title': 'Wie können wir Ihnen helfen?',
  'help.subtitle': 'Durchsuchen Sie unsere Wissensdatenbank oder kontaktieren Sie unser Support-Team',
  'help.search.placeholder': 'Suchen Sie nach Antworten...',
  'help.quickLinks.documentation': 'Dokumentation',
  'help.quickLinks.documentationDesc': 'Vollständige Anleitungen',
  'help.quickLinks.videos': 'Video-Tutorials',
  'help.quickLinks.videosDesc': 'Schritt-für-Schritt Videos',
  'help.quickLinks.support': 'Support kontaktieren',
  'help.quickLinks.supportDesc': 'Wir helfen Ihnen gerne',
  'help.quickLinks.demo': 'Demo buchen',
  'help.quickLinks.demoDesc': 'Persönliche Produktvorführung',
  'help.faq.title': 'Häufig gestellte Fragen',
  'help.faq.subtitle': 'Finden Sie schnell Antworten auf die wichtigsten Fragen',
  'help.categories.gettingStarted': 'Erste Schritte',
  'help.categories.reviewManagement': 'Bewertungsmanagement',
  'help.categories.aiResponse': 'AI-Auto-Antwort',
  'help.categories.socialMedia': 'Social Media Integration',
  'help.categories.googleBusiness': 'Google Business Management',
  'help.categories.pricing': 'Preise & Abrechnung',
  'help.faq.q1': 'Wie registriere ich mich bei reputrust.ai?',
  'help.faq.a1': 'Die Registrierung ist einfach: Klicken Sie auf \'Kostenlos testen\', geben Sie Ihre Unternehmensdaten ein und wählen Sie ein Preismodell. Nach der Bestätigung Ihrer E-Mail-Adresse können Sie sofort loslegen.',
  'help.faq.q2': 'Wie lange dauert die Einrichtung?',
  'help.faq.a2': 'Die grundlegende Einrichtung dauert nur 5-10 Minuten. Unser Onboarding-Assistent führt Sie durch alle wichtigen Schritte. Für erweiterte Funktionen wie API-Integrationen stehen wir Ihnen gerne zur Verfügung.',
  'help.faq.q3': 'Kann ich die Plattform vor dem Kauf testen?',
  'help.faq.a3': 'Ja! Wir bieten eine 7-tägige kostenlose Testphase an. Sie können alle Funktionen uneingeschränkt nutzen, ohne Zahlungsinformationen anzugeben.',
  'help.faq.q4': 'Wie generiere ich Bewertungen mit QR-Codes?',
  'help.faq.a4': 'Erstellen Sie in Ihrem Dashboard einen QR-Code, der direkt zu Ihrem Bewertungsformular führt. Drucken Sie diesen aus oder zeigen Sie ihn digital an. Kunden scannen den Code und können sofort eine Bewertung abgeben.',
  'help.faq.q5': 'Wie funktioniert der Bewertungsfilter?',
  'help.faq.a5': 'Unser intelligenter Filter leitet Kunden mit 1-3 Sternen zu einem internen Feedback-Formular, während 4-5 Sterne-Bewertungen direkt zu Google, Facebook oder anderen Plattformen weitergeleitet werden.',
  'help.faq.q6': 'Auf welchen Plattformen kann ich Bewertungen sammeln?',
  'help.faq.a6': 'Wir unterstützen über 20 Plattformen, darunter Google, Facebook, Trustpilot, TripAdvisor, Amazon, eBay, Airbnb und viele mehr.',
  'help.faq.q7': 'Wie funktioniert die AI-gestützte Antwortfunktion?',
  'help.faq.a7': 'Unsere KI analysiert jede Bewertung und generiert automatisch eine passende, professionelle Antwort im gewünschten Ton. Sie können den Ton (freundlich, professionell, humorvoll) und die Sprache individuell einstellen.',
  'help.faq.q8': 'Kann ich die AI-Antworten vor dem Versenden überprüfen?',
  'help.faq.a8': 'Ja, Sie haben die volle Kontrolle. Sie können wählen, ob Antworten automatisch gesendet oder zur Überprüfung vorgelegt werden sollen.',
  'help.faq.q9': 'In welchen Sprachen funktioniert die AI-Antwort?',
  'help.faq.a9': 'Die AI unterstützt über 30 Sprachen, darunter Deutsch, Englisch, Französisch, Spanisch, Italienisch und viele mehr. Die Sprache wird automatisch erkannt.',
  'help.faq.q10': 'Wie funktioniert die automatische Social-Media-Veröffentlichung?',
  'help.faq.a10': 'Positive Bewertungen (4-5 Sterne) werden automatisch als ansprechende Posts mit CI-konformen Grafiken auf Instagram, Facebook und LinkedIn geteilt. Die AI generiert passende Texte.',
  'help.faq.q11': 'Kann ich die Posts vor der Veröffentlichung bearbeiten?',
  'help.faq.a11': 'Ja, Sie können jeden Post vor der Veröffentlichung überprüfen und anpassen. Alternativ können Sie die vollautomatische Veröffentlichung aktivieren.',
  'help.faq.q12': 'Welche Social-Media-Plattformen werden unterstützt?',
  'help.faq.a12': 'Aktuell unterstützen wir Instagram, Facebook und LinkedIn. Weitere Plattformen sind in Planung.',
  'help.faq.q13': 'Wie verbinde ich mein Google-Unternehmensprofil?',
  'help.faq.a13': 'Gehen Sie zu Einstellungen > Integrationen > Google Business Profile und folgen Sie dem Authentifizierungsprozess. Die Verbindung ist in wenigen Minuten hergestellt.',
  'help.faq.q14': 'Welche Funktionen bietet das Google Business Management?',
  'help.faq.a14': 'Sie können Öffnungszeiten verwalten, Fotos hochladen, Posts erstellen, Statistiken einsehen und auf Bewertungen antworten – alles zentral in einem Dashboard.',
  'help.faq.q15': 'Kann ich mehrere Standorte verwalten?',
  'help.faq.a15': 'Ja, mit unserem Business- und Enterprise-Plan können Sie mehrere Standorte zentral verwalten.',
  'help.faq.q16': 'Welche Zahlungsmethoden werden akzeptiert?',
  'help.faq.a16': 'Wir akzeptieren Kreditkarten (Visa, Mastercard, American Express), SEPA-Lastschrift und PayPal.',
  'help.faq.q17': 'Kann ich jederzeit kündigen?',
  'help.faq.a17': 'Ja, Sie können jederzeit mit einer Frist von einem Monat zum Ende des Abrechnungszeitraums kündigen. Es gibt keine versteckten Kosten oder Kündigungsgebühren.',
  'help.faq.q18': 'Gibt es Rabatte bei jährlicher Zahlung?',
  'help.faq.a18': 'Ja, bei jährlicher Zahlung erhalten Sie 2 Monate kostenlos (entspricht ca. 17% Rabatt).',
  'help.contact.title': 'Haben Sie noch Fragen?',
  'help.contact.subtitle': 'Unser Support-Team steht Ihnen gerne zur Verfügung',
  'help.contact.email': 'E-Mail senden',
  'help.contact.phone': '07026-39999 88',

  // Webinars Page
  'webinars.badge': 'Live & On-Demand',
  'webinars.title': 'Webinare & Online-Schulungen',
  'webinars.subtitle': 'Lernen Sie von Experten, wie Sie Ihr Bewertungsmanagement optimieren und Ihre Online-Reputation nachhaltig verbessern können.',
  'webinars.upcoming.title': 'Kommende Webinare',
  'webinars.upcoming.subtitle': 'Melden Sie sich jetzt an und sichern Sie sich Ihren Platz',
  'webinars.past.title': 'Webinar-Aufzeichnungen',
  'webinars.past.subtitle': 'Schauen Sie sich vergangene Webinare jederzeit an',
  'webinars.level.beginner': 'Einsteiger',
  'webinars.level.advanced': 'Fortgeschritten',
  'webinars.attendees': 'Teilnehmer',
  'webinars.topics': 'THEMEN:',
  'webinars.register': 'Jetzt anmelden',
  'webinars.duration': 'Min.',
  'webinars.views': 'Aufrufe',
  'webinars.newsletter.title': 'Verpassen Sie kein Webinar mehr',
  'webinars.newsletter.subtitle': 'Abonnieren Sie unseren Newsletter und erhalten Sie Benachrichtigungen über neue Webinare',
  'webinars.newsletter.placeholder': 'Ihre E-Mail-Adresse',
  'webinars.newsletter.cta': 'Abonnieren',

  // Blog Article Page
  'article.share': 'Teilen:',
  'article.backToBlog': 'Zurück zum Blog',
  'article.relatedArticles': 'Weitere Artikel',
  'article.notFound.title': 'Artikel nicht gefunden',
  'article.notFound.description': 'Der angeforderte Artikel konnte nicht gefunden werden.',
  'article.notFound.cta': 'Zurück zum Blog',
};

export default deCommon;
